import apiAxios from './api.js'

export default {
	// 获取候选者数据
	newsListApi() {
		return apiAxios('GET', '/customer/vote-list')
	},
	newApi(id) {
		return apiAxios('GET', '/customer/vote/' + id)
	},
	voteApi(id) {
		return apiAxios('POST', '/customer/vote/' + id)
	},
	prize_list() {
		return apiAxios('POST', '/customer/prize-list')
	}
}